import httpService from '@/services/httpService'
import qs from 'qs'

const userHandler = {
  baseUrl: '/users/'
}

userHandler.sendAQuestion = (question) => new Promise((resolve, reject) => {
  const request = {
    url: 'sendQuestionNPCPower',
    data: qs.stringify({
      email: question.email,
      question: question.question
    })
  }

  httpService.post(request)
    .then(response => {
      resolve(response.data)
    })
    .catch(err => reject(err))
})

userHandler.getInstagramPosts = (mail) => new Promise((resolve, reject) => {
  const userInstagram = require('user-instagram')
  console.log('äsfasfas')
  // Gets informations about a user
  userInstagram('npcpowerclub') // Same as getUserData()
    .then(console.log)
    .catch(console.error)
})

export default userHandler
